module.exports = __webpack_public_path__ + "static/img/certify-site-img.d1e6037c.png";